module.exports = __webpack_public_path__ + "assets/img/cy-wx-code.10a876ff.png";